import styled from "styled-components";

export const AddTenantDeviceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 700px;
    box-sizing: border-box;
`;

export const TitleWrapper = styled.div`
    flex: 0 0 auto;
    margin: 10px 0px;
`;

export const Title = styled.div`
    font-size: 18px;
`;

export const FormWrapper = styled.div`
    flex: 1 1 auto;
`;

export const TenantDeviceList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 20px;
`;

export const TenantDeviceListHeader = styled.div`
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    text-align: center;
    background-color: #F0F0F0;
    border-top: 1px solid #CCCCCC;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
`;

export const TenantDeviceListBody = styled.div`
    font-weight: normal;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const TenantDeviceListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    border-top: 1px solid #CCCCCC;
`;

export const TenantDeviceInputWrapper = styled.div`
    width: 45%;
    padding: 5px;
    border-left: 1px solid #CCCCCC;
    box-sizing: border-box;

    &:last-child {
        border-right: 1px solid #CCCCCC;
    }
    &:last-child {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    & .ant-btn {
        padding: 10px 10px !important;
    }
`;

export const OperationWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 10px 0px;
`;
